import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

interface MapCircleProps {
  center: google.maps.LatLngLiteral;
  radius: number;
  fillColor?: string;
  fillOpacity?: number;
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
}

export function MapCircle({
  center,
  radius,
  fillColor = '#4285F4',
  fillOpacity = 0.15,
  strokeColor = '#4285F4',
  strokeOpacity = 0.4,
  strokeWeight = 1.5,
}: MapCircleProps) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const circle = new google.maps.Circle({
      map,
      // Depend on the primitive lat/lng (below), not the object identity, so a
      // new `center` literal from the parent each render doesn't re-create the circle.
      center: { lat: center.lat, lng: center.lng },
      radius,
      fillColor,
      fillOpacity,
      strokeColor,
      strokeOpacity,
      strokeWeight,
      clickable: false,
    });

    return () => {
      circle.setMap(null);
    };
  }, [map, center.lat, center.lng, radius, fillColor, fillOpacity, strokeColor, strokeOpacity, strokeWeight]);

  return null;
}
